import { Fragment, useEffect, useRef, useState } from "react";
import { isValidArray } from "../../Layout/Common/common";
import { BigImageViewer } from "./bigImageViewer";
import { loadImageouchScriptNew } from "./scripts";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";

export const ProductImageGallery = ({ params }) => {
  const [imageList, setImageList] = useState(null);
    const [selectImage, setSelectImage] = useState(0);
  const galleryRef = useRef(null);
  useEffect(() => {
    if (params) {
      setImageList(params);
      setTimeout(() => {
        loadImageouchScriptNew(galleryRef.current ?? document);
      }, 2000);
    }
  }, [params]);

  return (
    <Fragment>
      {imageList ? (
        <Fragment>
                  <BigImageViewer params={imageList} indexs={selectImage} />
          <div className="productsDetail-lft" ref={galleryRef}>
            <div
              className="productGallery"
              href={imageList[0]}
              style={{ display: "flex", alignItems: "center" }}
              data-bs-toggle="modal"
              data-bs-target="#productGalleryPopup"
            >
              <ImageWithDefault style={{ margin: "auto !important" }} src={imageList[0]} id="productGallery-img" />
            </div>
            <div className="small-img">
              <img
                src={"https://cdn.wes.com.au/wesreact/newui/plugins/pro-gallery/images/online_icon_right@2x.png"}
                className="icon-left"
                alt=""
                id="prev-img"
              />
              <div className="small-container">
                <div id="small-img-roll">
                  {isValidArray(imageList) &&
                    imageList.map((item, index) => (
                        <img key={index} src={item} className={"productGallery-small-img"} alt="" onClick={() => setSelectImage(index)} />
                    ))}
                </div>
              </div>
              <img
                src={"https://cdn.wes.com.au/wesreact/newui/plugins/pro-gallery/images/online_icon_right@2x.png"}
                className="icon-right"
                alt=""
                id="next-img"
              />
            </div>
          </div>
        </Fragment>
      ) : (
        <div className="productsDetail-lft">
          <div className="productGallery">
            <div className="skeleton skeleton-img" />
          </div>

          <div className="small-img">
            <div className="icon-left skeleton" style={{ width: 24, height: 24 }} />
            <div className="small-container">
              <div id="small-img-roll" style={{ display: "flex", gap: "8px" }}>
                {[...Array(5)].map((_, index) => (
                  <div key={index} className="skeleton skeleton-small-img" />
                ))}
              </div>
            </div>
            <div className="icon-right skeleton" style={{ width: 24, height: 24 }} />
          </div>
        </div>
      )}
    </Fragment>
  );
};
